import {useStore} from "vuex";
import {computed, ref} from "vue";
import {
  enrollSSL,
  // getCrseSnToDistCrseCd,
  getMyLearnTargetList,
  sslRoutes,
  // sslStatusStandard
} from "@/assets/js/modules/ssl/ssl-common";
import { ACT_GET_SOC_LCSN_STAT_LIST} from "@/store/modules/ssl/ssl-index";
import {
  // getItems,
  lengthCheck, ymdStrToDate
} from "@/assets/js/util";

import {EffectCoverflow} from "swiper";
import {useRouter} from "vue-router";

export const sslLicenseSetup = (props, {emit}) => {
  const router = useRouter();
  const store = useStore();
  const session = computed(() => store.state.auth.session);
  const sslLicenseList = ref([]);
  // 신용분석사: 10.25.(토)
  // 국제무역사: 11.15.(토)
  // 외환전문역 1, 2종: 11.22.(토)
  // 자산관리사(FP): 11.8.(토)
  // 한국재무설계사(AFPK): 8.23.(토) / 11.22.(토)
  // 투자자산운용사: 10.19.(일)
  // 자격증명	자격증코드
  // 자산관리사(FP)	WR69
  // 한국재무설계사(AFPK)	WR67
  // 투자자산운용사	WR2Y
  // 신용분석사	VQ03
  // 국제무역사	WR31
  // 외환전문역 1종	WR0H
  // 외환전문역 2종	WR0I
  const sslLicenseDate = ref([
    {lcsnNm:'자산관리사' ,lcsnCd:'WR69' , examDate:'20251108',image:'fp', buttonColor:'#f4f4b5' ,order:1},
    {lcsnNm:'한국재무설계사' ,lcsnCd:'WR67' , examDate:'20251122',image:'afpk', buttonColor:'#f4f4b5',order:2},
    {lcsnNm:'투자자산운용사',lcsnCd:'WR2Y' , examDate:'20251019',image:'im', buttonColor:'#f4f4b5',order:3},
    {lcsnNm:'신용분석사' ,lcsnCd:'VQ03' , examDate:'20251025',image:'cca',buttonColor:'#FBEED8' ,order:4},
    {lcsnNm:'국제무역사 1급' ,lcsnCd:'WR31' , examDate:'20251115',image:'itcs',buttonColor:'#FBEED8',order:5},
    {lcsnNm:'외환전문역 1종' ,lcsnCd:'WR0H' , examDate:'20251122',image:'ex1' , buttonColor:'#FBEED8' ,order:6},
    {lcsnNm:'외환전문역 2종' ,lcsnCd:'WR0I' , examDate:'20251122', image:'ex2',buttonColor:'#FBEED8' ,order:7},
    {lcsnNm:'기타' ,lcsnCd:'ETC' , examDate:'',image:'etc',buttonColor:'#daf8fd',order:8},
  ])

  const doSearch = (lcsnNm) =>{
    if(lcsnNm.indexOf('외환전문역') > -1){
      lcsnNm = lcsnNm.replace(' ','');
    }
    emit('search',lcsnNm)
  }



  const mergeArrayByKey = (arr1, arr2, key) => {
    // const map2 = new Map(arr2.map(item =>[item[key],item]));
    //
    // return arr1.map(item =>{
    //   const item2 = map2.get(item[key]);
    //   return item2 ? {...item, ...item2}: {...item};
    // });
    const combinedArray = [...arr1, ...arr2];
    const mergedObjects = combinedArray.reduce((acc, item) => {
      acc[item[key]] = acc[item[key]] ? {...acc[item[key]], ...item} :{...item};
      return acc;
    }, {});
    return Object.values(mergedObjects);
  }

  const licenseCodes = ref([]);
  const licRegModal = ref(false);
  const strLcsnCds = computed(() =>sslLicenseDate.value.filter(x=> x.examDate != '' ).map(y=> y.lcsnCd).join(','));


  const getLcsnExamDueDate = (strDate) =>{
    const today = new Date();
    const diffMs =  today - ymdStrToDate(strDate)  ;
    return Math.ceil((diffMs / (1000 * 60 *60*24))-1);
  }


  const lrnTrgtGrpMstSns = ref(Object.values(sslRoutes).filter(x=>x.statusViewYn=='Y' && x.key == 'selfLic').map(y=>y.group[0].lrnTrgtGrpMstSn).toString());
  // console.log(lrnTrgtGrpMstSns.value.toString());
  const getSocLcsnStat = () => {
    store.dispatch(`ssl/${ACT_GET_SOC_LCSN_STAT_LIST}`,{lrnTrgtGrpMstSn:lrnTrgtGrpMstSns.value, strLcsnCds:strLcsnCds.value})
      .then(res => {
        if (lengthCheck(res)) {
          sslLicenseList.value = mergeArrayByKey(res.items,sslLicenseDate.value,'lcsnCd')
                          .sort((a,b) => {
                            if(a.socLcsnRegYn =='Y' && b.socLcsnRegYn !='Y') return -1
                            if(a.socLcsnRegYn !='Y' && b.socLcsnRegYn =='Y') return 1
                          return a.order - b.order}).map( x=> {
            //자격증 정보와 시험일 매핑하여 컴포넌트 전달



              let imgUrl=require('@/assets/lxp/images/ssl/home/ic_'+x.image+'.svg');




            return {
              lcsnCd : x.lcsnCd,
              lcsnNm : x.lcsnNm,
              socLcsnRegAllCnt:x.socLcsnRegAllCnt,
              socLcsnRegYn: x.socLcsnRegYn,
              socLcsnGetYn: x.socLcsnGetYn,
              examDate: getLcsnExamDueDate(x.examDate),
              thumbUrl: imgUrl,
              buttonColor: x.buttonColor
            }
          });
        }
      }).catch(e => {
      console.error(e);
      sslLicenseList.value = [];
    });
  }
  getSocLcsnStat();

  const goMain = (key, lrnTrgtGrpMstSn)  => {
    router.push({name: 'SSLMain', params: {distCrseCd: key, lrnTrgtGrpMstSn}}).then(() => {});
  }
  const goGoal = ()=>{
    router.push({ name: 'SSLMobileLicRegModal'  , query: {lrnTrgtGrpMstSn :lrnTrgtGrpMstSns.value }}).then(()  =>{});
  }

  const myGroup = computed(() => store.state.ssl.group);
  const goLearn=(key, lrnTrgtGrpMstSn)=>{

    if (lrnTrgtGrpMstSn > 0) {
      goMain(key, lrnTrgtGrpMstSn);
    } else {
      // 그룹은 있지만 SSL 그룹러닝에 입과되지 않는 경우 강제 입과를 한다.
      if (key === 'group' && myGroup.value.distCrseSn > 0) {
        enrollSSL(lrnTrgtGrpMstSn, result => {
          if (result > 0) {
            getMyLearnTargetList(() => {
              goMain(key, lrnTrgtGrpMstSn);
            }).then(() => {});
          } else {
            // showMessage('서버처리 중 일시적인 장애가 발생하였습니다.<br>잠시 후 다시 시도 해 주시기 바랍니다.');
          }
        });
      }else {
        goMain(key, lrnTrgtGrpMstSn);
        // enroll.key = key;
        // enroll.toggle = true;
      }
    }
  }
  return {
    session,
    sslLicenseList,
    modules: [EffectCoverflow],
    goLearn,
    licRegModal,
    licenseCodes,
    getSocLcsnStat,
    doSearch,
    goGoal,
  }

}